// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';

// Components
import DefaultErrorRenderer from '../../error/errorBoundary/DefaultErrorRenderer';
import { useTranslator } from '../../i18n/useTranslator';

// Styles
import './PopupErrorRenderer.scss';

const getErrorDetails = ({ popupId, error }) => `Popup ID: ${popupId}
Error: ${error && error.toString()}
Stack: ${get('stack', error)}`;

const PopupErrorRenderer = (props) => {
    const translate = useTranslator('popup', 'error.popupBoundary');
    return (
        <DefaultErrorRenderer
            {...props}
            className="PopupErrorRenderer"
            heading={translate('heading')}
            getErrorDetails={getErrorDetails}
        />
    );
};

PopupErrorRenderer.propTypes = {
    popupId: PropTypes.string,
    error: PropTypes.object,
};

export default PopupErrorRenderer;
